<div class="container-fluid float-monitoring-page">
    @let balance = (floatBalance$ | async);
    @let unavailable = (balanceError$ | async) ?? false;
    @let unavailableText = (balanceUnavailableText$ | async);

    <app-available-float-card [balance]="balance?.balance != null ? (balance!.balance | toMajor | currency:'ZAR':'R ') : null"
                              [unavailable]="unavailable"
                              [unavailableText]="unavailableText ?? defaultUnavailableText"
                              (topUp)="openTopUpDialog()"></app-available-float-card>

    <app-float-events class="float-monitoring-events"></app-float-events>
</div>
